"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InputContainerStyle = void 0;
const styled_components_1 = require("styled-components");
const style_1 = __importDefault(require("style"));
exports.InputContainerStyle = (0, styled_components_1.css) `
  ${style_1.default.Text.Definition.Paragraph};
  background: ${props => props.theme.Color.Layout.Foreground};
  border-radius: ${style_1.default.Design.Rounding.Tertiary};
  border: 1px solid ${props => props.theme.Color.Layout.Line};
  color: ${props => props.theme.Color.Text.Primary};
  flex: 2;
  padding: ${style_1.default.Layout.Spacing.Tiny};
  width: 100%;
`;
